import { render } from "./UniPicker.vue?vue&type=template&id=7a4c70d3&scoped=true&ts=true"
import script from "./UniPicker.vue?vue&type=script&lang=ts"
export * from "./UniPicker.vue?vue&type=script&lang=ts"

import "./UniPicker.vue?vue&type=style&index=0&id=7a4c70d3&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4c70d3"]])

export default __exports__